import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Componentes } from '../../providers/componentes';
import { EventosProvider } from '../../providers/eventos';

@Component({
  selector: 'page-evento-detalhes',
  templateUrl: 'evento-detalhes.html',
})
export class EventoDetalhesPage {

  item: any = [];
  id: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public componentes: Componentes,
    public eventosService: EventosProvider) {
    this.id = this.navParams.get('id');
  }

  ionViewDidLoad() {
    this.componentes.apresentaLoading('Carregando...');

    this.eventosService.getEvento(this.id).then(
      data => {
        this.componentes.removeLoading();
        this.item = data;
      }
    )

  }

}



// WEBPACK FOOTER //
// ./src/pages/evento-detalhes/evento-detalhes.ts